/*
  Set-Ersparnis-Block: setzt den Aufklapp-Zustand je Breakpoint.

  Der Block wird serverseitig geschlossen ausgeliefert (bzw. offen, wenn
  "auf Mobil geöffnet" aktiv ist). Ohne JS bleibt er per Klick nutzbar.
  Der Zustand wird nicht persistiert; sobald der Nutzer selbst klickt,
  greift der Breakpoint-Default nicht mehr.
*/
(() => {
  const SELECTOR = '.vq-set-ersparnis';
  const DESKTOP = window.matchMedia('(min-width: 750px)');
  const states = new WeakMap();

  const apply = (root) => {
    const state = states.get(root);
    if (!state || state.userToggled) return;

    const shouldBeOpen = DESKTOP.matches ? state.openDesktop : state.openMobile;
    if (state.details.open === shouldBeOpen) return;

    state.programmatic = true;
    state.details.open = shouldBeOpen;
  };

  const setup = (root) => {
    if (states.has(root)) return;

    const details = root.querySelector('.vq-set-ersparnis__details');
    if (!details) return;

    const state = {
      details,
      openDesktop: root.dataset.openDesktop === 'true',
      openMobile: root.dataset.openMobile === 'true',
      userToggled: false,
      programmatic: false,
    };
    states.set(root, state);

    // Erst ab hier darf CSS den Summary auf Desktop ausblenden.
    root.classList.add('vq-set-ersparnis--js');

    details.addEventListener('toggle', () => {
      if (state.programmatic) {
        state.programmatic = false;
        return;
      }
      state.userToggled = true;
    });

    apply(root);
  };

  const init = () => document.querySelectorAll(SELECTOR).forEach(setup);

  DESKTOP.addEventListener('change', () => document.querySelectorAll(SELECTOR).forEach(apply));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Nach einem Variantenwechsel ersetzt product-info.js das Markup des Blocks.
  if (typeof subscribe === 'function') {
    subscribe('variant-change', init);
  }
})();
